module.exports = __webpack_public_path__ + "img/emojis-blisser-love.87e69506.png";